import { config } from '@iheartjane/config';

/* eslint-disable-next-line no-restricted-imports */
import type { Id } from '@jane/shared/models';

import { request } from '../lib/request';

const storeUrl = (storeId: Id) => `${config.apiPath}/stores/${storeId}`;

export class StoreSource {
  static get(id: Id, params: any = {}) {
    return request(
      storeUrl(id),
      {
        method: 'GET',
      },
      params
    );
  }
}

export const getStoreSource = (id: Id) => ({
  url: storeUrl(id),
  requireAuth: true,
});
